import SideMenu from '@/containers/side-menu/SideMenu.vue';
import RegisterPriceTicket from '@/pages/register-price-ticket/RegisterPriceTicket.vue';

export default {
  path: '/price-ticket',
  name: 'RegisterPriceTicket',
  components: {
    mainContent: RegisterPriceTicket,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'price-ticket',
    },
    breadcrumb: {
      title: 'Gerenciar preços',
      paths: [{ title: 'Sistema' }],
    },
  },
};
